export const getBuildNumber = () => {
    const branch = window.CURRENT_BRANCH ?? '';
    const lastCommit = (window.CURRENT_COMMIT ?? '').slice(0, 8);
    return `${branch} @ ${lastCommit}`;
};
